<template>
  <WrapperContent>
    <li>
      <div class="house-info">
        <span class="title" v-text="`Данные дома №${house.building}`"></span>
        <span class="subtitle" v-text="house.addressRow.split(',')[0]"></span>
      </div>
      <Spinner :isLoading="isLoading">
        <div class="uk-child-width-auto uk-grid-small">
          <ListDetailStick
            text="Количество помещений"
            :icon="'castle'"
            :value="info.apartmentCount"
          ></ListDetailStick>
          <ListDetailStick
            text="Количество жильцов"
            :icon="'tenants'"
            :value="info.occupantCount"
          ></ListDetailStick>
          <ListDetailStick
            text="Количество собственников"
            :icon="'owners'"
            :value="info.ownerCount"
          ></ListDetailStick>
        </div>
      </Spinner>
      <b-table
        :header="header"
        :headers="headers"
        :columns="columns"
        :uri="tableUri"
        :rowSize="rowSize"
        :sort="'apartmentNumberAsLong,ASC'"
        style="margin-top: 30px"
      ></b-table>
    </li>
  </WrapperContent>
</template>

<script>
import ListDetailStick from '@/views/pages/apartment/ListDetailStick'
import {residentialStatus} from '@/views/variables/residential_status'

import {mapActions} from 'vuex'
import config from '@/config'

export default {
  name: 'HouseTab',
  components: {ListDetailStick},
  data: () => ({
    info: {
      apartmentCount: 0,
      occupantCount: 0,
      ownerCount: 0
    },
    uri: 'apartment/house/',
    header: '',
    headers: [],
    columns: [],
    isLoading: false
  }),
  props: {
    house: {
      type: Object,
      required: true
    },
    rowSize: {
      type: Number,
      default: config.TABLE_ROW_COUNT
    }
  },
  methods: {
    ...mapActions({
      fetchHouseInfo: 'house/HOUSE_INFO'
    }),
    initTable() {
      this.header = 'Список помещений'
      this.headers = [
        {
          name: '№ помещения',
          filter: {type: 'text', field: 'apartmentNumber', operator: ':'},
          minWidth: 180
        },
        {name: 'Площадь', size: 'м2', minWidth: 135},
        {name: 'Подъезд', filter: {type: 'text', field: 'entrance', operator: ':'}, minWidth: 140},
        {name: 'Этаж', filter: {type: 'text', field: 'floor', operator: ':'}, minWidth: 110},
        {
          name: 'Назначение',
          filter: {
            type: 'radio',
            field: 'isResidential',
            values: residentialStatus,
            operator: ':',
            position: 'left-top'
          },
          minWidth: 160
        },
        {name: '', filter: {type: 'clear'}}
      ]
      this.columns = [
        {name: 'apartmentNumber', type: String},
        {name: 'area', type: String},
        {name: 'entrance', type: String},
        {name: 'floor', type: String},
        {name: 'isResidential', type: 'residentialStatus'},
        {name: 'more', type: 'more'}
      ]
    },
    getHouseInfo() {
      this.isLoading = true
      this.fetchHouseInfo(this.house.id).then(resp => {
        this.info = resp
        this.isLoading = false
      })
    }
  },
  mounted() {
    this.getHouseInfo()
    this.initTable()
  },
  computed: {
    tableUri() {
      return this.uri + this.house.id
    }
  }
}
</script>

<style lang="scss" scoped>
.house-info {
  font-size: 1.5rem;
  margin-bottom: 12px;

  .title {
    color: #222222;
  }

  .subtitle {
    margin-left: 14px;
    color: rgba(34, 34, 34, 0.6);
  }
}
</style>
